// extracted by mini-css-extract-plugin
export default {"gameInfoIcon":"GameMoreInfo__gameInfoIcon--2Z-"};